import { useEffect } from 'react'

import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from './StoreContext'

import Api from 'services/api'

type Options = {
  sortAttribute: string,
  sortDirection: string,
  page: number,
  size: string,
  query: string,
  filters: string,
  refreshTimestamp: number
}

const useCustomers = (options: Options) => { // TODO: name doesn't match the file name
  const { session: { dealerId } } = useSessionContext()

  const {
    customers,
    setCustomers,
    customersMetadata,
    setCustomersMetadata,
    arePagedCustomersLoaded,
    setArePagedCustomersLoaded
  } = useStoreContext()

  useEffect(() => {
    setCustomers(null)
    setCustomersMetadata(null)
    setArePagedCustomersLoaded(false)

    Api.Customers.list(dealerId, options)
      .then((res) => {
        const { items, ...metadata } = res

        setCustomers(items)
        setCustomersMetadata(metadata)
        setArePagedCustomersLoaded(true)
      })
      .catch(() => {
        setCustomers(null)
        setCustomersMetadata(null)
        setArePagedCustomersLoaded(true)
      })
  }, [dealerId, options?.sortAttribute, options?.sortDirection, options?.page, options?.query, options?.filters, options?.refreshTimestamp]) // eslint-disable-line react-hooks/exhaustive-deps

  return { customers, customersMetadata, arePagedCustomersLoaded }
}

export default useCustomers
